import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component.jsx';
import { httpCancelTransaction } from '../../Hooks/orders/order.hooks';
import SecondaryButton from '../../Components/Buttons/SecondaryButton/SecondaryButton.component';
import PrimaryButtonComponent from '../../Components/Buttons/PrimaryButton/PrimaryButton.component';
const CancelledPayment = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isCompany = searchParams.get('company') === 'true';

  useEffect(() => {
    const transactionId = searchParams.get('transaction_id');

    if (!transactionId) return;

    async function cancelTransaction() {
      await httpCancelTransaction(transactionId);
    }

    cancelTransaction();
  }, [searchParams]);

  return (
    <div
      style={{
        maxWidth: 500,
        margin: '4rem auto',
        padding: '2rem',
        textAlign: 'center',
        height: '100vh',
      }}
    >
      <HelmetHelper
        title="Payment Cancelled"
        description="Your payment was cancelled and no purchase was completed. Return to your cart when you're ready to continue."
        noIndex
      />
      <h1>Payment Cancelled</h1>
      <p>
        Your payment was not completed. If you cancelled by mistake, you can try
        again or return to your dashboard.
      </p>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '1rem',
          marginTop: '2rem',
        }}
      >
        {isCompany ? (
          <PrimaryButtonComponent
            functionName={() => navigate('/company')}
            style={{ marginLeft: '1rem' }}
            span="Go to Company Dashboard"
          />
        ) : (
          <PrimaryButtonComponent
            functionName={() => navigate('/cart')}
            style={{ marginLeft: '1rem' }}
            span=" Back to Cart"
          />
        )}
        <SecondaryButton
          functionName={() => navigate('/user')}
          span="Go to Dashboard"
        />
      </div>
    </div>
  );
};

export default CancelledPayment;
